import mitt from 'mitt'
import type { Message } from '~/api/interface'
import type { MessageInfo } from '~/constants/message'

export enum EVENT {
  NOTIFICATION = 'notification',
  YANBI_CHANGE = 'yanbi_change',
  ADMIN_CHANGE = 'admin_change',
  UPDATE_USER = 'update_user', // 购买成功
  UPDATE_PROJECT_TIP = 'update_project_tip', // 首次打开更新内容弹窗
  FIND_PWD = 'find_pwd', // 找回密码
  SWITCH_WECHAT_LOGIN = 'switch_wechat_login', // 切换微信登录
}

export interface BaseMessage {
  message: Message
  config: MessageInfo
}

// export interface NotificationMessage extends BaseMessage {}

export const emitter = mitt<{
  [EVENT.NOTIFICATION]: BaseMessage
  [EVENT.YANBI_CHANGE]: void
  [EVENT.ADMIN_CHANGE]: void
  [EVENT.UPDATE_USER]: void
  [EVENT.UPDATE_PROJECT_TIP]: void
  [EVENT.FIND_PWD]: void
  [EVENT.SWITCH_WECHAT_LOGIN]: void
}>()
